import { ModalManager } from "@circle-react/components/Layout/ModalManagerProvider";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { WorkflowsMomentumModal } from "@/react/components/WorkflowsMomentumModal";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";

const COMMENT_FLAGGED_CONTENTABLE_TYPE = "Comment";

export interface ReportFormValues {
  reported_reason_body: string;
  reported_reason_type: string;
}

interface UseReportCommentMutationParams {
  commentId: number;
  onSuccess: () => void;
}

export const useReportCommentMutation = ({
  commentId,
  onSuccess,
}: UseReportCommentMutationParams) => {
  const { success, error } = useToast();
  const { currentCommunityMember } = usePunditUserContext();

  return useMutation({
    mutationFn: (formData: ReportFormValues) =>
      reactQueryPost(internalApi.flaggedContent.create(), {
        flagged_content: {
          ...formData,
          flagged_contentable_id: commentId,
          flagged_contentable_type: COMMENT_FLAGGED_CONTENTABLE_TYPE,
        },
      }),
    onSuccess: () => {
      success(t("comments.report.alerts.success"), {
        duration: "short",
        shouldUseProgress: false,
      });

      if (isCommunityAdmin(currentCommunityMember)) {
        void ModalManager.show(WorkflowsMomentumModal, {
          templateKey: "ai_moderate_new_comments",
        });
      }

      onSuccess();
    },
    onError: () => {
      error(t("comments.report.alerts.failure"));
    },
  });
};
